import type { RouteLocationNormalizedLoaded } from 'vue-router'

let previousRoute: null | RouteLocationNormalizedLoaded = null

/** 当前客户端导航序号，用于区分新旧页面实例的滚动就绪标记。 */
let routeScrollNavigationId = 0

/** 获取上一次客户端路由，用于判断导航来源。 */
export function getPreviousRoute() {
  return previousRoute
}

/** 记录导航发生前的客户端路由。 */
export function rememberRoute(route: RouteLocationNormalizedLoaded) {
  previousRoute = route
}

/** 在客户端导航开始时递增序号。 */
export function beginRouteNavigation() {
  routeScrollNavigationId += 1
}

/** 获取当前客户端导航序号。 */
export function getRouteScrollNavigationId() {
  return routeScrollNavigationId
}

/** 判断当前导航是否由浏览器历史恢复滚动位置。 */
export function isScrollRestorationNavigation() {
  return import.meta.client && Boolean(window.history.state?.scroll)
}
